import { AppFeaturePreference } from "./common-behaviors";
import AppNativeBridge from "./common-bridge";
class Preferences {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    // set the application dynamic properties, e.g. app version
    static setAppProperties(props) {
        if (!props)
            return;
        if (props.appVersion && typeof props.appVersion !== 'undefined')
            this._appVersion = props.appVersion;
        this._appProperties = props;
    }
    static getAppProperties() {
        return this._appProperties;
    }
    // set the app behavior preferences, e.g. swym will check the app native behaviors
    static setAppPreferences(appSettings) {
        AppFeaturePreference.setAppPreferences(appSettings);
    }
    // check if in native application
    static isNativeApp() {
        if (window && typeof window.electron !== 'undefined')
            return true;
        else if (window && window.nsWebViewInterface)
            return true;
        return false;
    }
    static isMobileApp() {
        return (window && window.nsWebViewInterface);
    }
    static isDesktopApp() {
        return (window && window.electron);
    }
    // check if on same native localhost
    static isNativeSameDomain(url) {
        return (window && window.location && window.location.hostname === url.hostname);
    }
    // get custom requirejs configuration for native app
    static getNativeAppRequireConfig() {
        if (!this.isNativeApp())
            return undefined;
        else {
            // get current app version injected
            if (window && window.nsWAP && window.nsWAP.appVersion && typeof window.nsWAP.appVersion !== 'undefined') {
                this._appVersion = window.nsWAP.appVersion;
            }
            return {
                dsEnv: {
                    env: 'MOBILE'
                },
                proxies: {
                    ajax: (`${window.location.origin}/_api/proxy/ajax`),
                    passport: (`${window.location.origin}/_api/proxy/passport`),
                },
                requirePaths: {
                    'WAP': (`${window.location.origin}/wap/${this._appVersion}`),
                    'WAP2': (`${window.location.origin}/WapInterface/${this._appVersion}`),
                }
            };
        }
    }
    // get the pairing platform from native app
    static async getAppPairingPlatform() {
        return AppNativeBridge.getSelectedPlatform();
    }
    static async getTrackerData() {
        return AppNativeBridge.getTrackerData();
    }
    static async getGDPRPreferences() {
        return AppNativeBridge.getGDPRPreferences();
    }
    // initialize the native app preferences...
    static async intializeNativeAppPreferences() {
        try {
            const appPref = await AppNativeBridge.getAppPreferences();
            if (appPref) {
                this.setAppProperties(appPref.appProperties);
                this.setAppPreferences(appPref.appFeatureActivation);
            }
            console.log('intializeNativeAppPreferences', appPref);
        }
        catch (error) {
            console.log('intializeNativeAppPreferences error', error);
        }
        return Promise.resolve();
    }
}
Preferences._appVersion = '1.0';
export default Preferences;
//# sourceMappingURL=common-preferences.js.map